import { render, staticRenderFns } from "./salaryTop.vue?vue&type=template&id=a8fd466e&scoped=true&"
import script from "./salaryTop.vue?vue&type=script&lang=js&"
export * from "./salaryTop.vue?vue&type=script&lang=js&"
import style0 from "./salaryTop.vue?vue&type=style&index=0&id=a8fd466e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fd466e",
  null
  
)

export default component.exports